import { ReactNode } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export { TableCell, TableRow };

export const TablePlain = <T,>({
  children,
  data = [],
  headers = []
}: {
  children: (data: T | []) => ReactNode;
  data: T | [];
  headers: string[];
}) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label='user table'>
        <TableHead>
          <TableRow>
            {headers.map((header: string) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children(data)}</TableBody>
      </Table>
    </TableContainer>
  );
};
